<div class="absolute inset-0 w-full h-full">
  <!-- Background Image -->
  <img
    [src]="imageUrl()"
    [alt]="quote()"
    class="absolute inset-0 w-full h-full object-cover opacity-90"
  />

  <!-- Gradient Overlay (softer for quote/icon to match auth pages) -->
  @if (variant() === 'testimonial') {
  <div
    class="absolute inset-0 bg-gradient-to-t from-black/90 via-black/30 to-transparent"
  ></div>
  } @else {
  <div
    class="absolute inset-0 bg-linear-to-t from-black/80 via-black/40 to-transparent"
  ></div>
  }

  <!-- Content -->
  <div
    class="absolute inset-0 flex flex-col px-12 pb-16 lg:p-16 w-full max-w-2xl justify-end xl:px-20 xl:pb-24"
  >
    @switch (variant()) { @case ('testimonial') {
    <blockquote
      class="font-serif text-3xl lg:text-4xl text-white leading-tight mb-8 font-medium"
    >
      "{{ quote() }}"
    </blockquote>
    <div class="flex items-center gap-4">
      @if (avatarUrl()) {
      <img
        [src]="avatarUrl()"
        [alt]="authorName()"
        class="w-14 h-14 rounded-full border-2 border-primary object-cover shadow-md"
      />
      }
      <div>
        <div class="flex items-center gap-1 mb-1">
          <span class="text-white font-semibold text-lg tracking-wide"
            >{{ authorName() }}</span
          >
          <div class="flex text-primary">
            <span class="material-icons !text-sm">star</span>
            <span class="material-icons !text-sm">star</span>
            <span class="material-icons !text-sm">star</span>
            <span class="material-icons !text-sm">star</span>
            <span class="material-icons !text-sm">star</span>
          </div>
        </div>
        <p class="text-gray-300 text-sm font-light">{{ authorRole() }}</p>
      </div>
    </div>
    } @case ('quote') {
    <blockquote
      class="mb-6 font-serif text-white leading-tight {{
            quoteSize() === 'lg'
              ? 'text-4xl md:text-5xl'
              : 'text-3xl lg:text-4xl'
          }} {{
            quoteItalic() ? 'italic' : 'font-medium'
          }}"
    >
      "{{ quote() }}"
    </blockquote>
    @if (subtitle()) {
    <p class="text-lg font-medium text-white/90">{{ subtitle() }}</p>
    } } @case ('icon') { @if (iconName()) {
    <div
      class="mb-8 flex h-16 w-16 items-center justify-center rounded-full border border-white/30 bg-white/10 backdrop-blur-md"
    >
      <span class="material-icons text-3xl font-light text-white"
        >{{ iconName() }}</span
      >
    </div>
    }
    <h1
      class="font-serif text-4xl font-semibold leading-tight text-white mb-4 {{
            titleItalic() ? 'italic' : ''
          }}"
    >
      @if (titleInQuotes()) { "{{ title() || quote() }}" } @else { {{ title() ||
      quote() }} }
    </h1>
    @if (subtitle()) {
    <p
      class="font-display text-lg font-light leading-relaxed text-white/80 max-w-md"
    >
      {{ subtitle() }}
    </p>
    } } }
  </div>
</div>
